(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-exo-landing-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-mkexo-page]');
    const update = () => roots.forEach((root) => root.classList.toggle('is-scrolled', window.scrollY > 24));
    update();
    window.addEventListener('scroll', update, { passive: true });

    roots.forEach((root) => {
      const drawer = root.querySelector('[data-mkexo-drawer]');
      const backdrop = root.querySelector('.mkexo-drawer-backdrop');
      const openButton = root.querySelector('[data-mkexo-drawer-open]');
      const closeButtons = root.querySelectorAll('[data-mkexo-drawer-close]');
      if (!drawer || !backdrop || !openButton) return;

      const setOpen = (isOpen) => {
        drawer.classList.toggle('is-open', isOpen);
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        openButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        backdrop.hidden = !isOpen;
        requestAnimationFrame(() => backdrop.classList.toggle('is-open', isOpen));
        document.documentElement.classList.toggle('mkexo-drawer-open', isOpen);
        document.body.classList.toggle('mkexo-drawer-open', isOpen);
        if (isOpen) {
          const closeButton = drawer.querySelector('.mkexo-drawer__close');
          if (closeButton) closeButton.focus({ preventScroll: true });
        } else {
          openButton.focus({ preventScroll: true });
        }
      };

      openButton.addEventListener('click', () => setOpen(true));
      closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
      drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
      });
      drawer.querySelectorAll('[data-mkexo-localization-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.closest('form');
          if (form) form.submit();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkexo-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mkexo-shipping-bar')) {
    customElements.define('mkexo-shipping-bar', class extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold || 0);
        this.currency = this.dataset.currency || 'USD';
        this.message = this.querySelector('[data-message]');
        this.progress = this.querySelector('[data-progress]');
        this.fill = this.querySelector('[data-progress-fill]');
        this.refresh = this.refresh.bind(this);
        this.handleCartLinesUpdate = this.handleCartLinesUpdate.bind(this);
        this.refresh();
        document.addEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);
        document.addEventListener('cart:update', this.refresh);
        document.addEventListener('cart:updated', this.refresh);
        document.addEventListener('cart:refresh', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);
        document.removeEventListener('cart:update', this.refresh);
        document.removeEventListener('cart:updated', this.refresh);
        document.removeEventListener('cart:refresh', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      handleCartLinesUpdate(event) {
        if (!event?.promise) {
          this.refresh();
          return;
        }

        event.promise
          .then(({ cart }) => {
            const amount = Number(cart?.cost?.totalAmount?.amount);
            if (!Number.isFinite(amount)) {
              this.refresh();
              return;
            }

            this.render(Math.round(amount * 100), Number(cart.totalQuantity || 0));
          })
          .catch(() => this.refresh());
      }

      async refresh(event) {
        const eventCart = event?.detail?.cart;
        if (eventCart && typeof eventCart.total_price === 'number') {
          this.render(eventCart.total_price, eventCart.item_count || 0);
          return;
        }

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js', {
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const cart = await response.json();
          this.render(cart.total_price, cart.item_count);
        } catch (error) {
          return;
        }
      }

      render(total, itemCount) {
        if (!this.threshold || !this.message || !this.progress || !this.fill) return;
        const remaining = Math.max(this.threshold - total, 0);
        const percent = Math.min((total / this.threshold) * 100, 100);
        let text;

        if (total >= this.threshold) {
          text = this.dataset.successText;
        } else if (!itemCount) {
          text = this.dataset.emptyText.split('[amount]').join(this.format(this.threshold));
        } else {
          text = this.dataset.remainingText.split('[amount]').join(this.format(remaining));
        }

        this.message.textContent = text;
        this.fill.style.width = percent + '%';
        this.progress.setAttribute('aria-valuenow', Math.round(percent));
      }

      format(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currency,
          maximumFractionDigits: this.currency === 'JPY' ? 0 : 2
        }).format(cents / 100);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
